import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { GetLevelOneApi } from "../LevelOne/LevelOneAction";
import { GetLevelTwoWithLevelOneIDApi } from "../LevelTwo/LevelTwoAction";
import { UploadLevelThreeFileApi } from "./LevelThreeAction";
import { setHeading } from "../../../accounts/account.actions";
import _ from "lodash";
import Select from 'react-select';
import Swal from 'sweetalert';
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import { GlobalSpinner } from "../../../../../global/globalFunctions";


const UploadLevelThree = (props) => {
    const [levelOneId, setLevelOneId] = useState();
    const [levelOneName, setLevelOneName] = useState();
    const [levelTwoId, setLevelTwoId] = useState();
    const [levelTwoName, setLevelTwoName] = useState();
    const [uploadLevelThreeFile, setUploadLevelThreeFile] = useState("");
    const [visibleAlert, setAlertVisible] = useState(false);
    const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);


    function SaveLevelThree() {
        props.UploadLevelThreeFileApi({
            levelOneId: levelOneId,
            levelOneName: levelOneName,
            levelTwoId: levelTwoId,
            levelTwoName: levelTwoName,
            file: uploadLevelThreeFile,
        },
            handleVisible,
            handleDangerVisible
        );
        setLevelOneId("")
        setLevelTwoId("")
    }
    const handleVisible = (msg) => {
        setAlertVisible(true)
        setTimeout(() => {
            setAlertVisible(false)
        }, 9000);
        Swal({
            title: "Success",
            text: msg,
            icon: "success",
            button: "Ok",
        });
    }
    const handleDangerVisible = (error) => {
        setDangerVisibleAlert(true)
        setTimeout(() => {
            setDangerVisibleAlert(false)
        }, 9000);
        Swal({
            title: "Error",
            text: error,
            icon: "error",
            button: "Ok",
        });
    }

    const handleChangeLevelOne = (selectedOption) => {
        setLevelOneId(selectedOption.value);
        setLevelOneName(selectedOption.label);
        props.GetLevelTwoWithLevelOneIDApi(selectedOption.value)
    };
    const getLevelOneList = !_.isEmpty(props.levelOneList) && props.levelOneList.data.map((x) => {
        let data = { value: x._id, label: `${x.key} - ${x.name}` };
        return data;
    });

    const handleChangeLevelTwo = (selectedOption) => {
        setLevelTwoId(selectedOption.value);
        setLevelTwoName(selectedOption.label);
    };
    const getLevelTwoList = !_.isEmpty(props.levelTwoWithLevelOneIdList) && props.levelTwoWithLevelOneIdList.map((x) => {
        let data = { value: x._id, label: `${x.allKey} - ${x.levelTwoName}` };
        return data;
    });

    useEffect(() => {
        props.GetLevelOneApi();
        props.setHeading("Upload Level Three");
    }, []);

    return (
        <>
            {props.isFetchingLevelOne || props.isUploadingLevelThree ? (
                <GlobalSpinner />
            ) : (
                <Container fluid>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b> Select Level 1 *</b></Form.Label>
                                <Select
                                    placeholder="Select Level 1"
                                    onChange={handleChangeLevelOne}
                                    options={getLevelOneList}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b> Select Level 2 *</b></Form.Label>
                                <Select
                                    placeholder="Select Level 2"
                                    onChange={handleChangeLevelTwo}
                                    options={getLevelTwoList}
                                    isDisabled={_.isEmpty(levelOneId)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group controlId="formFile" className="mb-3">
                                <Form.Label><b>Upload Level Three File *</b></Form.Label>
                                <Form.Control
                                    placeholder="Upload Level Three File"
                                    type="file"
                                    accept=".xls, .xlsx"
                                    onChange={(e) => setUploadLevelThreeFile(e.target.files[0])}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <div className="sendDiv">
                        {_.isEmpty(levelOneId) || _.isEmpty(levelTwoId) || !uploadLevelThreeFile ? (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> UPLOAD FILE </Button>
                        ) : (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={SaveLevelThree}> UPLOAD FILE </Button>
                        )}
                    </div>

                </Container>
            )}
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        setHeading: (data) => dispatch(setHeading(data)),
        GetLevelOneApi: () => dispatch(GetLevelOneApi()),
        GetLevelTwoWithLevelOneIDApi: (levelOneId) => dispatch(GetLevelTwoWithLevelOneIDApi(levelOneId)),
        UploadLevelThreeFileApi: (data, handleVisible, handleDangerVisible) => dispatch(UploadLevelThreeFileApi(data, handleVisible, handleDangerVisible)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isUploadingLevelThree: state.LevelThreeReducer.isUploadingLevelThree,
    isFetchingLevelOne: state.LevelOneReducer.isFetchingLevelOne,
    levelOneList: state.LevelOneReducer.levelOneList,
    levelTwoWithLevelOneIdList: state.LevelTwoReducer.levelTwoWithLevelOneIdList,
});

export default connect(mapStateToProps, mapDispatchToProps)(UploadLevelThree);